module.exports = __webpack_public_path__ + "static/media/holodrone.27db8816.jpg";